"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPENDENCIES_OR_PEER_FIELDS = exports.DEPENDENCIES_FIELDS = void 0;
// NOTE: The order in this array is important.
exports.DEPENDENCIES_FIELDS = [
    'optionalDependencies',
    'dependencies',
    'devDependencies',
];
exports.DEPENDENCIES_OR_PEER_FIELDS = [
    ...exports.DEPENDENCIES_FIELDS,
    'peerDependencies',
];
//# sourceMappingURL=misc.js.map